import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-level=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyLevel") : stack1), depth0))
    + "\"";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-full-width=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFullWidth") : stack1), depth0))
    + "\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\n  <div class=\"column small-12 content\">\n    <div\n      class=\"sticky spa-sticky\"\n      "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyLevel") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":5,"column":81}}})) != null ? stack1 : "")
    + "\n      "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFullWidth") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":6},"end":{"line":6,"column":94}}})) != null ? stack1 : "")
    + "\n    >\n      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "\n    </div>\n  </div>\n</div>\n\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/all-cards-english-cc-module",
  "version": "4.0.0",
  "id": "allCardsEnglishCcModule",
  "containerID": "creditCardsAllCardsEnglishCcModule",
  "moduleName": "credit-cards-all-cards-english-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "all-cards-english-cc-module",
  "data": {
    "init": "allCardsEnglishCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "customClass",
    "type": "string",
    "values": ["overview-page"],
    "default": "overview-page",
    "description": "custom classes"
  }, {
    "name": "stickyLevel",
    "type": "Number",
    "default": 2,
    "description": "sticky level"
  }, {
    "name": "stickyFullWidth",
    "type": "boolean",
    "default": true,
    "description": "sticky full width"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/*
 * all-cards-english-cc-module
 * module_js_id: allCardsEnglishCcModuleJS
 *
 * Copyright (c) 2017-12-4 removed
 */

/**
 * @export
 * @class allCardsEnglishCcModuleJS
 * @extends {Module}
 */
class allCardsEnglishCcModuleJS extends Module {
  /**
   * Constructor
   * @param {object} options options object
   * @param {object} context context object
   *
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  init() {}
}
registerModuleClass({
  moduleClass: allCardsEnglishCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { allCardsEnglishCcModuleJS as default, moduleConfig };
